module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/chapel_01_bg-07b4151af73c1197e65a06b75b8c22e1.png";